export { default } from './BottomNavigationAction';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/BottomNavigationAction/index.js
// module id = 809
// module chunks = 2